import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";
import { type PayoutSchedule } from "@src/appV2/redesign/Accounts/PayoutSettings/api/schema";
import { PromotionBanner } from "@src/appV2/redesign/system/ui-components";

export interface OutstandingBalanceBannerProps {
  availableBalanceInCents: number;
  payoutSchedule: PayoutSchedule | undefined;
  onClick: () => void;
  isPayingOutBalance?: boolean;
}

export function OutstandingBalanceBanner(props: OutstandingBalanceBannerProps) {
  const { availableBalanceInCents, payoutSchedule, isPayingOutBalance, onClick } = props;

  return (
    <PromotionBanner
      title={`You have a ${formatDollarsAsUsd(availableBalanceInCents / 100)} balance!`}
      icon="dollar-with-circle"
      borderVariant="solid"
      borderColor={(theme) => theme.palette.border?.primary ?? ""}
      backgroundColor={(theme) => theme.palette.background?.quaternary ?? ""}
      ctaButtonText={payoutSchedule === "instant" ? "Send my payment now" : "Send my payment"}
      ctaButtonIsLoading={isPayingOutBalance}
      sx={(theme) => ({ height: "100%", borderWidth: theme.borderWidth.thin })}
      onClick={onClick}
    />
  );
}
